import React from 'react';
import { Tabs, Tab, Card } from "react-bootstrap";
import ChalanItemsTableForReturnAndUpdate from "./ChalanItemsTableForReturnAndUpdate";
import ChalanReturnForm from "./ChalanReturnForm";
import ChalanDetailUpdateForm from "./ChalanDetailUpdateForm";
import ChalanItemCostChangeForm from "./ChalanItemCostChangeForm";

function ChalanUpdateReturnTabs({ is_stock_return }) {
    return (
        <>
            <Card>
                <Card.Body className="pt-0">
                    <Tabs
                        defaultActiveKey="items"
                        id="uncontrolled-tab-example"
                        className="mb-3"
                    >
                        {/*chalan detail update form*/}
                        {/* <Tab eventKey="chalanDetail" className="d-none" title="Detail">
                            
                            <ChalanDetailUpdateForm is_stock_return={is_stock_return} />
                        </Tab> */}
                        <Tab eventKey="items" title="Items">
                            {/*chalan items*/}
                            <ChalanItemsTableForReturnAndUpdate />

                            {/*items update and return tabs*/}
                            <Tabs
                                defaultActiveKey={!is_stock_return ? "update" : "return"}
                                id="uncontrolled-tab-example"
                                className="mb-3"
                            >
                                {!is_stock_return && <Tab eventKey="update" title="Update">
                                    {/*chalan item cost change*/}
                                    <ChalanItemCostChangeForm />
                                </Tab>}
                                <Tab eventKey="return" title="Return">
                                    {/*chalan return form*/}
                                    <ChalanReturnForm is_stock_return={is_stock_return} />
                                </Tab>

                            </Tabs>
                        </Tab>

                    </Tabs>
                </Card.Body>
            </Card>
        </>
    );
}

export default ChalanUpdateReturnTabs;